import {connect} from 'react-redux';
import {push} from 'connected-react-router'
import {additionalBranchQuestionSelect} from '../../redux/selector/additionalBranchSelector'
import {setAdditionalBranchQuestionAnswer} from '../../redux/slice/additionalBranchSlice'
import {
    Header, 
    Paragraph, 
    Button
} from '../../components/RegularComponents'
import TopNavigationBar from "../TopNavigationBar"
import {replaceUrlParams} from '../../app/utils'
import Navigation from '../Navigation';
import { resetAdditionalBranchApplications } from '../../redux/slice/additionalApplicationsSlice';

const AdditionalBranchQuestion = (props) => {
    const {dispatch} = props
    const {applicationType, applicationMode} = props.match.params
    const additionalBranchQuestion = props.additionalBranchQuestion[applicationType] ? 
            props.additionalBranchQuestion[applicationType] : props.additionalBranchQuestion

    return (
        <>
            <Navigation {...props} />
            <div className={"container"}>
                <TopNavigationBar {...props} />
                <div className="row">
                    <div className="col-lg-8">
                        <Header header={additionalBranchQuestion.header} />
                        <Paragraph text={additionalBranchQuestion.text} />
                        <div className="row">
                            <div className="col-auto">
                                <Button 
                                    id="additional-branches-yes"
                                    className="ns-btn-yes-no btn-default"
                                    text={"Yes"}
                                    buttonType={"regular_primary"}
                                    onClick={() => {
                                        dispatch(setAdditionalBranchQuestionAnswer("yes"))
                                        dispatch(push(replaceUrlParams(additionalBranchQuestion.navigation.yes,applicationType, applicationMode)))
                                    }}
                                />
                            </div>
                            <div className="col-auto">
                                <Button 
                                    id="additional-branches-no"
                                    className="ns-btn-yes-no btn-default"
                                    text={"No"}
                                    buttonType={"regular_primary"}
                                    onClick={() => {
                                        dispatch(setAdditionalBranchQuestionAnswer("no"))
                                        dispatch(resetAdditionalBranchApplications())
                                        dispatch(push(replaceUrlParams(additionalBranchQuestion.navigation.no,applicationType, applicationMode)))
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default connect(additionalBranchQuestionSelect)(AdditionalBranchQuestion)
